const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the Image Editor component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */

app.directive('imageEditor', [function () {
  return {
    restrict: 'A',
    replace: false,
    scope: {
      imageUrl: '=',
      modifiedUrl: '=',
      inputId: '@',
      editorState: '='
    },
    link: function (scope, element, attrs) {
      if (window.Aviary && window.Aviary.launchData) {
        window.Aviary.launchData.forceCropPreset = null;
        window.Aviary.launchData.initTool = "";
        window.Aviary.launchData.cropPresets = ['Custom', 'Original', ['Square', '1:1'], '3:2', '5:3', '4:3', '5:4', '6:4', '7:5', '10:8', '16:9'];
        delete window.Aviary.launchData.forceCropMessage;
        if (scope.editorState) {
          scope.editorState.available = true;
        }
      }

      var aviary = {};
      var reset = true;
      window.setTimeout(function() {
        aviary.input = document.getElementById(scope.inputId);
        var options = {
          apiKey: '75bfa8a0-99d6-4396-85f6-882c32d2a988',
          theme: "minimum",
          tools: ["crop","orientation","resize","enhance","effects","color","lighting","sharpness","focus","text"],
          cropPresets: ['Custom', 'Original', ['Square', '1:1'], '3:2', '5:3', '4:3', '5:4', '6:4', '7:5', '10:8', '16:9'],
          onLoad: function() {
            if (scope.editorState) {
              scope.editorState.available = true;
            }
          },
          onSave: function(imageID, newURL) {
            aviary.input.src = newURL;
            scope.modifiedUrl = newURL;
            scope.$apply();
            reset = false;
            aviary.featherEditor.close();
          },
          onError: function(errorObj) {
            alert(errorObj.message);
          },
          onClose: function(isDirty) {
            if (reset) {
              scope.modifiedUrl = 'reset';
              scope.$apply();
            }
          }
        };

        aviary.featherEditor = new Aviary.Feather(options);

        aviary.launchEditor = function(id, src) {
          var launchOptions = {
            image: id,
            url: src
          };
          this.featherEditor.launch(launchOptions);
          return false;
        };

        element.bind('click', function(e) {
          e.preventDefault();
          aviary.input.src = scope.imageUrl;
          aviary.launchEditor(scope.inputId, aviary.input.src);
        });
      });      
    }
  }
}]);
